import Vue from 'vue'
import store from '..'
import firebase from 'firebase/app'
import 'firebase/firestore'

export default {
  namespaced: true,
  state () {
    return {
      groups: [],
      reference: null,
      initial: {
        key: null,
        name: null,
        address2: null,
        address: null,
        city: null,
        state: null,
        zip: null,
        policy: null,
        target: null,
        phone: null,
        email: null,
        web: null,
        avatar: null,
        users: {},
        schools: {},
        enable: true,
        public: true,
        owner: null,
        chats: null,
        classroom: true,
        chatsShare: false,
        color: '#1976D2FF',
        task: true,
        createdAt: null,
        updatedAt: null
      }
    }
  },
  getters: {
    groups (state) {
      return state.groups
    },
    reference (state) {
      return state.reference
    },
    initial (state) {
      return state.initial
    }
  },
  mutations: {
    init (state, payload) {
      state.groups = payload
    },
    add (state, payload) {
      state.groups.push(payload)
    },
    update (state, payload) {
      const index = state.groups.findIndex(group => group.key === payload.key)
      if (index !== -1) {
        Vue.set(state.groups, index, payload)
      }
    },
    remove (state, payload) {
      const index = state.groups.findIndex(group => group.key === payload.key)
      if (index !== -1) {
        state.groups.splice(index, 1)
      }
    },
    reference (state, payload) {
      state.reference = payload
    }
  },
  actions: {
    init ({ commit }) {
      return new Promise((resolve) => {
        commit('init', [])
        resolve()
      })
    },
    subscribe ({ commit }, payload) {
      var boot = true
      var temp = []
      return new Promise((resolve, reject) => {
        commit('init', [])
        const db = firebase.firestore()
        var dbRef = db.collection('groups')
        var reference = null
        if (payload) {
          reference = dbRef.where('schools.' + payload, '==', true).onSnapshot(snapshots => {
            if (snapshots.empty) {
              resolve()
            }
            snapshots.docChanges().forEach(change => {
              var data = JSON.parse(JSON.stringify(change.doc.data()))
              if (boot && change.type === 'added') {
                temp.push(data)
              } else if (change.type === 'added') {
                commit('add', data)
              } else if (change.type === 'modified') {
                commit('update', data)
              } else if (change.type === 'removed') {
                commit('remove', data)
              }
            })
            if (boot) {
              boot = false
              commit('init', temp)
            }
            resolve()
          })
        } else {
          reference = dbRef.onSnapshot(snapshots => {
            if (snapshots.empty) {
              resolve()
            }
            snapshots.docChanges().forEach(change => {
              var data = JSON.parse(JSON.stringify(change.doc.data()))
              if (boot && change.type === 'added') {
                temp.push(data)
              } else if (change.type === 'added') {
                commit('add', data)
              } else if (change.type === 'modified') {
                commit('update', data)
              } else if (change.type === 'removed') {
                commit('remove', data)
              }
            })
            if (boot) {
              boot = false
              commit('init', temp)
            }
            resolve()
          })
        }
        commit('reference', reference)
      })
    },
    unSubscribe ({ commit }) {
      var reference = store.getters['groups/reference']
      return new Promise((resolve) => {
        if (reference) {
          reference()
          commit('reference', null)
          commit('init', [])
          resolve()
        } else {
          resolve()
        }
      })
    },
    write ({ commit }, payload) {
      return new Promise((resolve) => {
        const db = firebase.firestore()
        var ref = null
        if (payload.key) {
          ref = db.collection('groups').doc(payload.key)
        } else {
          ref = db.collection('groups').doc()
          payload.key = ref.id
          var user = this.getters['auth/user']
          payload.owner = user.uid
        }
        ref.set(payload)
          .then(function () {
            console.log('Document successfully written!')
            resolve(ref.id)
          })
          .catch(function (error) {
            console.error('Error writing document: ', error)
            resolve()
          })
      })
    },
    delete ({ commit }, payload) {
      return new Promise((resolve) => {
        const db = firebase.firestore()
        db.collection('groups').doc(payload).delete().then(function () {
          console.log('Document successfully deleted!')
          resolve()
        }).catch(function (error) {
          console.error('Error removing document: ', error)
          resolve()
        })
      })
    }
  }
}
